import React, { useState } from 'react';
import { makeStyles, Box, Modal } from '@material-ui/core';
import Navbar from './Navbar';
import DrawerItem from './DrawerItem';
import Footer from './Footer';
// import BackToTop from './BackToTop';

import AppConfig from "../../model/AppConfig";
import { useAppConfig } from "../../context/AppConfigContext";

const useStyle = makeStyles((theme) => ({
  toolbar: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    backgroundColor: '#fff',
  },
  modalContent: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: '#fff',
    padding: 24,
    borderRadius: 8,
    boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
    minWidth: 240,
  },
  modalTitle: {
    fontSize: '1.2rem',
    fontWeight: 600,
    marginBottom: 16,
  },
  dropdownItem: {
    display: "flex",
    alignItems: "center", // Align flag & text horizontally
    padding: "8px 12px 8px 0px",
    cursor: "pointer",
    whiteSpace: "nowrap", // Prevents text from wrapping
  },
  flagIcon: {
    width: "20px",
    height: "20px",
    marginRight: "8px", // Space between flag & label
    display: "inline-block",
  },
  dropdownLabel: {
    fontSize: "16px",
    color: "#000", // Ensure visible text
    flexGrow: 1, // Ensures text doesn't disappear
  },
}));

const Layout = ({ children }) => {
  const classes = useStyle();

  const [open, setOpen] = useState(false);

  const { setAppConfigDict } = useAppConfig();
  const [modalOpen, setModalOpen] = useState(false);

  const toggleOpen = () => {
    setOpen(!open);
  };

  const setCountry = (newCountry) => {
    console.log(`Setting country to ${newCountry}`)
    setAppConfigDict((prev) => ({ ...prev, country: newCountry }));
    setModalOpen(false);
  };

  const handleModalToggle = () => {
    setModalOpen(prev => !prev);
  };

  return (
    <>
      <Navbar toggleOpen={toggleOpen} />
      {/* <Hidden lgUp> */}
        <DrawerItem variant="temporary" open={open} onClose={toggleOpen} handleModalToggle={handleModalToggle}/>
      {/* </Hidden> */}
      <div className={classes.content}>
        <div id="top" />
        <div>{children}</div>
      </div>
      {/* <BackToTop /> */}
      <Footer />
      <Modal open={modalOpen} onClose={handleModalToggle}>
          <Box className={classes.modalContent}>
            <div className={classes.modalTitle}>Select Country</div>

            <div className={classes.dropdownItem} onClick={() => setCountry('us')}>
              <img src={AppConfig.getFlagImg("us")} alt="US Flag" className={classes.flagIcon} />
              <span className={classes.dropdownLabel}>US</span>
            </div>

            <div className={classes.dropdownItem} onClick={() => setCountry('ca')}>
              <img src={AppConfig.getFlagImg("ca")} alt="Canada Flag" className={classes.flagIcon} />
              <span className={classes.dropdownLabel}>Canada</span>
            </div>
          </Box>
        </Modal>
    </>
  );
};

export default Layout;
